import * as yup from 'yup';

import { FormErrors } from '@blockpulse3/data/shared';
import { requiredNumberField, requiredStringField } from '@blockpulse3/web-client/forms';

import { IPrivateFundraisingParametersForm } from '../types';
import { IFundraisingSubscriberCheck } from './types';

export const privateFundraisingParametersSchema = yup.object({
  name: requiredStringField,
  subscriptionPeriod: yup.object({
    label: requiredStringField,
    value: requiredNumberField,
  }),
  valuation: requiredNumberField,
  pricePerShare: requiredNumberField,
  assetType: requiredStringField,
}) as yup.ObjectSchema<IPrivateFundraisingParametersForm>;

export const fundraisingSubscriberDefaultValues = {
  isLegal: false,
  subscriber: {
    email: '',
    name: '',
    identificationNumber: '',
    amount: 0,
    admissionFees: 0,
    verified: false,
    minimalAmount: null,
    maximalAmount: null,
  },
};

export const checkSubscriberSchema = yup.object({
  maxSubscribers: yup.boolean().isTrue('CONDITIONS_FIELD').required(FormErrors.RequiredField),
}) as yup.ObjectSchema<IFundraisingSubscriberCheck>;

export const checkSubscriberDefaultValues: IFundraisingSubscriberCheck = {
  maxSubscribers: true,
};
